import React from "react";

const CarouselRighttInactive = () => {
    return (
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="15.5" fill="#fff" stroke="#DDD"/>
            <path d="M14.354 9.646a.5.5 0 0 0-.708.708l.708-.708zM20.5 16.5l.34.367a.5.5 0 0 0 .014-.72l-.354.353zm-6.84 5.633a.5.5 0 1 0 .68.734l-.68-.734zm-.014-11.78 6.5 6.5.708-.707-6.5-6.5-.708.708zm6.515 5.78-6.5 6 .678.734 6.5-6-.678-.734z" fill="#939393"/>
        </svg>
    );
};

export default CarouselRighttInactive;